var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, reaction } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { NamedRoutes } from "./NamedRoutes";
import { BlockchainSigningType } from "healthex-common/blockchain.dtos";
export class AdminOrganizationSettingsViewModel {
    constructor(container) {
        this.editingOrganizationDetails = false;
        this.editingLoginSettings = false;
        this.editingPasswordSettings = false;
        this.adminUIManager = container.adminUIManager;
        this.routingUIManager = container.routingUIManager;
        this.organizationsManager = container.organizationsManager;
        reaction(() => this.adminUIManager.sectionToExpand, async () => {
            this.expandSectionIfNecessary();
        }, { fireImmediately: true });
    }
    get ssoEnabled() {
        var _a;
        const organization = this.organizationsManager.myOrganization.value;
        if (organization === NOT_LOADED)
            return NOT_LOADED;
        return (_a = organization === null || organization === void 0 ? void 0 : organization.ssoEnabled) !== null && _a !== void 0 ? _a : false;
    }
    get useAuthenticatorApp() {
        const organization = this.organizationsManager.myOrganization.value;
        if (organization === NOT_LOADED)
            return NOT_LOADED;
        return (organization === null || organization === void 0 ? void 0 : organization.blockchainSigningType) === BlockchainSigningType.SIGNING_APP;
    }
    expandSectionIfNecessary() {
        if (this.adminUIManager.sectionToExpand === "DETAILS") {
            this.toggleEditingOrganizationDetails();
        }
        else if (this.adminUIManager.sectionToExpand === "AUTHENTICATION") {
            this.toggleLoginSettings();
        }
    }
    newUser() {
        this.routingUIManager.navigateTo(NamedRoutes.ADMIN_USERS_CREATE);
    }
    viewUserDetails(userId) {
        this.adminUIManager.navigateToUserDetails(userId);
    }
    toggleEditingOrganizationDetails() {
        this.editingOrganizationDetails = !this.editingOrganizationDetails;
    }
    toggleLoginSettings() {
        this.editingLoginSettings = !this.editingLoginSettings;
    }
    togglePasswordSettings() {
        this.editingPasswordSettings = !this.editingPasswordSettings;
    }
    async onLoginSettingsSave() {
        this.toggleLoginSettings();
        await this.organizationsManager.waitForReloadOrganizations();
    }
    async onPasswordSettingsSave() {
        this.togglePasswordSettings();
        await this.organizationsManager.waitForReloadOrganizations();
    }
}
__decorate([
    observable
], AdminOrganizationSettingsViewModel.prototype, "editingOrganizationDetails", void 0);
__decorate([
    observable
], AdminOrganizationSettingsViewModel.prototype, "editingLoginSettings", void 0);
__decorate([
    observable
], AdminOrganizationSettingsViewModel.prototype, "editingPasswordSettings", void 0);
__decorate([
    computed
], AdminOrganizationSettingsViewModel.prototype, "ssoEnabled", null);
__decorate([
    computed
], AdminOrganizationSettingsViewModel.prototype, "useAuthenticatorApp", null);
